import { ThemeProvider } from "styled-components";

import { shopTheme } from "./shopTheme";

export default function ShopThemeProvider({ children }) {
  return <ThemeProvider theme={shopTheme}>{children}</ThemeProvider>;
}
